<div *ngIf="isCreateAndSendProductSection()">
  <div *ngIf="isProductsList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addApprovedProduct"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addAuthorisedProduct',
            nodeType: 2,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addApprovedProduct"
        >New Authorised Product</label
      >
    </span>
    <br />
    <span class="spanClass">
      <input
        type="checkbox"
        id="addDevelopmentProduct"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addDevelopmentProduct',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addDevelopmentProduct"
        >New Development Product</label
      >
    </span>
  </div>

  <div *ngIf="isSubstancesList() && this.authService.isEMAOrganisation()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addApprovedSubstance"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addApprovedSubstance',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addApprovedSubstance"
        >New Approved Substance</label
      >
    </span>
    <br />
    <span class="spanClass">
      <input
        type="checkbox"
        id="addDevelopmentSubstance"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addDevelopmentSubstance',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addDevelopmentSubstance"
        >New Development Substance</label
      >
    </span>
  </div>

  <div *ngIf="isSourcesList() && this.authService.isEMAOrganisation()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSource"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addSource',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSource">New Source</label>
    </span>
  </div>

  <div *ngIf="isOrganisationsList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addMAH"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addOrganisation',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addMAH">New MAH</label>
    </span>
    <br />
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSponsor"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addOrganisation',
            nodeType: 2,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSponsor">New Sponsor</label>
    </span>
  </div>

  <div *ngIf="isATCsList()">
    <div *ngIf="this.authService.isEMAOrganisation()">
      <span class="spanClass">
        <input
          type="checkbox"
          id="addATCCodeStandard"
          (click)="
            onButtonAction('add', {
              nodeTypeToCreateName: 'addATCCode',
              nodeType: 3,
              operationType: 1
            });
            $event.preventDefault()
          "
        />
        <label class="checkBoxLabel" for="addATCCodeStandard"
          >New Standard ATC Code</label
        >
      </span>
      <br />
      <span class="spanClass">
        <input
          type="checkbox"
          id="addATCCodeProposed"
          (click)="
            onButtonAction('add', {
              nodeTypeToCreateName: 'addATCCode',
              nodeType: 2,
              operationType: 1
            });
            $event.preventDefault()
          "
        />
        <label class="checkBoxLabel" for="addATCCodeProposed"
          >New Proposed ATC Code</label
        >
      </span>
      <br />
    </div>
    <span class="spanClass">
      <input
        type="checkbox"
        id="addATCCodeDevelopment"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addATCCode',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addATCCodeDevelopment"
        >New Development ATC Code</label
      >
    </span>
  </div>

  <div *ngIf="isPharmaceuticalFormsList()">
    <div *ngIf="this.authService.isEMAOrganisation()">
      <span class="spanClass">
        <input
          type="checkbox"
          id="addPharmaceuticalFormStandard"
          (click)="
            onButtonAction('add', {
              nodeTypeToCreateName: 'addPharmaceuticalForms',
              nodeType: 3,
              operationType: 1
            });
            $event.preventDefault()
          "
        />
        <label class="checkBoxLabel" for="addPharmaceuticalFormStandard"
          >New Standard Pharmaceutical Form</label
        >
      </span>
      <br />
      <span class="spanClass">
        <input
          type="checkbox"
          id="addPharmaceuticalFormProposed"
          (click)="
            onButtonAction('add', {
              nodeTypeToCreateName: 'addPharmaceuticalForms',
              nodeType: 2,
              operationType: 1
            });
            $event.preventDefault()
          "
        />
        <label class="checkBoxLabel" for="addPharmaceuticalFormProposed"
          >New Proposed Pharmaceutical Form</label
        >
      </span>
      <br />
    </div>
    <span class="spanClass">
      <input
        type="checkbox"
        id="addPharmaceuticalFormDevelopment"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addPharmaceuticalForms',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addPharmaceuticalFormDevelopment"
        >New Development Pharmaceutical Form</label
      >
    </span>
  </div>

  <div *ngIf="isRoutesOfAdministrationsList()">
    <div *ngIf="this.authService.isEMAOrganisation()">
      <span class="spanClass">
        <input
          type="checkbox"
          id="addRouteOfAdministrationStandard"
          (click)="
            onButtonAction('add', {
              nodeTypeToCreateName: 'addRoutesOfAdministration',
              nodeType: 3,
              operationType: 1
            });
            $event.preventDefault()
          "
        />
        <label class="checkBoxLabel" for="addRouteOfAdministrationStandard"
          >New Standard Route of Administration</label
        >
      </span>
      <br />
      <span class="spanClass">
        <input
          type="checkbox"
          id="addRouteOfAdministrationProposed"
          (click)="
            onButtonAction('add', {
              nodeTypeToCreateName: 'addRoutesOfAdministration',
              nodeType: 2,
              operationType: 1
            });
            $event.preventDefault()
          "
        />
        <label class="checkBoxLabel" for="addRouteOfAdministrationProposed"
          >New Proposed Route of Administration</label
        >
      </span>
      <br />
    </div>
    <span class="spanClass">
      <input
        type="checkbox"
        id="addRouteOfAdministrationDevelopment"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addRoutesOfAdministration',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addRouteOfAdministrationDevelopment"
        >New Development Route of Administration</label
      >
    </span>
  </div>

  <div *ngIf="isAttachmentsList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addPPIAttachment"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addAttachment',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addPPIAttachment"
        >New PPI Attachment</label
      >
    </span>
    <br />
    <span class="spanClass">
      <input
        type="checkbox"
        id="addPSIAttachment"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addAttachment',
            nodeType: 2,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addPSIAttachment"
        >New PSI Attachment</label
      >
    </span>
  </div>

  <div *ngIf="isMasterFileLocationsList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addMasterFileLocation"
        (click)="
          onButtonAction('add', {
            nodeTypeToCreateName: 'addMasterFileLocations',
            nodeType: 1,
            operationType: 1
          });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addMasterFileLocation"
        >New Master File Location</label
      >
    </span>
  </div>

  <!-- SubNodes Products -->

  <div *ngIf="isMedicinalProductTypesList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addMedicinalProductType"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType: 1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addMedicinalProductType"
        >New Medicinal Product Type</label
      >
    </span>
  </div>

  <div *ngIf="isAuthorisedPharmaceuticalFormList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addAuthorisedPharmaceuticalForm"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addAuthorisedPharmaceuticalForm"
        >New Authorised Pharmaceutical Form</label
      >
    </span>
  </div>

  <div *ngIf="isPharmaceuticalProductsList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addPharmaceuticalProducts"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addPharmaceuticalProducts"
        >New Pharmaceutical Product</label
      >
    </span>
  </div>

  <div *ngIf="isDrugRouteList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addDrugRoute"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addDrugRoute">New Drug Route</label>
    </span>
  </div>

  <div *ngIf="isDrugIngredientsList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addDrugIngredients"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addDrugIngredients"
        >New Drug Ingredient</label
      >
    </span>
  </div>

  <div *ngIf="isMedicalDevicesList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addMedicalDevices"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addMedicalDevices"
        >New Medical Device</label
      >
    </span>
  </div>

  <div *ngIf="isDrugsATCList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addDrugsATC"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addDrugsATC">New Drug ATC</label>
    </span>
  </div>

  <div *ngIf="isDrugIndicationList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addDrugIndication"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addDrugIndication"
        >New Drug Indication</label
      >
    </span>
  </div>

  <div *ngIf="isPreviousEVCodeList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addPreviousAuthorisedEVCode"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 2, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addPreviousAuthorisedEVCode"
        >New Previous Authorised EV Code</label
      >
    </span>
    <br />
    <span class="spanClass">
      <input
        type="checkbox"
        id="addPreviousDevelopmentEVCode"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addPreviousDevelopmentEVCode"
        >New Previous Development EV Code</label
      >
    </span>
  </div>

  <div *ngIf="isProductAttachmentsList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addProductAttachments"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addProductAttachments"
        >New Product Attachment</label
      >
    </span>
  </div>

  <!-- SubNodes Substances -->

  <div *ngIf="isSubstanceTranslationsList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSubstanceTranslations"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSubstanceTranslations"
        >New Substance Translation</label
      >
    </span>
  </div>

  <div *ngIf="isSubstanceAliasList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSubstanceAlias"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSubstanceAlias"
        >New Substance Alias</label
      >
    </span>
  </div>

  <div *ngIf="isSubstanceAliasTranslationList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSubstanceAliasTranslation"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSubstanceAliasTranslation"
        >New Translation</label
      >
    </span>
  </div>

  <div *ngIf="isSubstanceInternationalCodeList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSubstanceInternationalCode"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSubstanceInternationalCode"
        >New International Code</label
      >
    </span>
  </div>

  <div *ngIf="isSubstanceParentCodeList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSubstanceParentCode"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSubstanceParentCode"
        >New Substance Parent Code</label
      >
    </span>
  </div>

  <div *ngIf="isSubstancePreviousEVCodeList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSubstancePreviousEVCode"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSubstancePreviousEVCode"
        >New Previous EV Code</label
      >
    </span>
  </div>

  <div *ngIf="isSubstanceAttachmentsList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSubstanceAttachments"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSubstanceAttachments"
        >New Substance Attachment</label
      >
    </span>
  </div>

  <div *ngIf="isSubstancePreviousNameCodeList()">
    <span class="spanClass">
      <input
        type="checkbox"
        id="addSubstancePreviousNameCode"
        (click)="
          onButtonAction('add', { nodeTypeToCreateName: '', nodeType: 1, operationType:1 });
          $event.preventDefault()
        "
      />
      <label class="checkBoxLabel" for="addSubstancePreviousNameCode"
        >New Previous Name or Code</label
      >
    </span>
  </div>
</div>
